<template>
<div>
<flash-message class="myCustomClass"></flash-message>
<v-card-title>
<h2>{{ ctitle }}</h2>
<v-spacer></v-spacer>
<v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
        <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.text }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >(+{{ filteredheaders.length - 1 }} others)</span>
      </template>
        </v-select>
      </v-flex>

<v-btn icon class="mx-0" @click="download">
  <v-icon title="Excel Download" color="green">save_alt</v-icon>
</v-btn>

<v-btn icon class="mx-0" @click="reset">
   <v-icon title="Reload" color="blue">refresh</v-icon>
</v-btn>

<v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

</v-card-title>   

<v-data-table :footer-props="{'items-per-page-options': [10,50,100,2000]}"  :headers="filteredheaders"
:loading=progress_bar_loading :items="filteredResults" :search="search" class="elevation-1" :options.sync="pagination">

<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

<template slot="headers" slot-scope="props">
<tr>
<th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
</tr>
<tr class="grey lighten-3">

<th v-for="header in props.headers" :key="header.text">

<div v-if="filters.hasOwnProperty(header.value)">

<v-select flat hide-details small multiple clearable :items="columnValueList(header.value)" v-model="filters[header.value]">
</v-select>

</div>

</th>

</tr>
</template>

<template slot="items" slot-scope="props">
<td class="table-fit" v-for="header in filteredheaders"><span style="font-size: 100%;" v-bind:class="BackgroundColor(props.item, header.value)">{{ props.item[header.value] }}</span></td>
</template>

<v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>

</v-data-table>

</v-card>

</div>
</template>

<script>
import XLSX from 'xlsx';

export default {
	data () {
		return {
app_name: process.env.MIX_APP_NAME,
search: this.search_value,
fill:[],
filteredheaders: [],
filteredheaderarray: [],
headerarray:[],
progress_bar_loading: true,
dialog: false,
		rowsPerPageItems: [10,50,100,2000],
		headers: [
                { text: 'Student name', value: 'student_name', sortable: true, },
                { text: 'Type', value: 'requesttype', sortable: true, },
                { text: 'Course info', value: 'course_info', sortable: true, },
                { text: 'Call', value: 'call', sortable: true, },
                { text: 'Response', value: 'log', sortable: true, },
                { text: 'Created by', value: 'advisor_name', sortable: true, },
                { text: 'Created on', value: 'created_at', sortable: true, },
		],
		
		filters: {
		student_name:[],
		requesttype:[],
		call:[],
		log:[],
		course_info:[],
		advisor_name:[],
		created_at:[],
		},

		selected:[],
		pagination: {

		},

		Results:[],
	}
	},
	     created () {
		     this.initialize()
	     },
props: {
url: {
type: String,
      required: true,
     },
ctitle: {
             type: String,
                   required: true,
                              },
search_value: {
type: String,
      required: true,
     }     
       },
       computed:{
		filteredResults() {
		return this.Results.filter(d => {
			return Object.keys(this.filters).every(f => {
				return this.filters[f].length < 1 || this.filters[f].includes(d[f])
			})
		})
		}
       },

methods:
       {
		columnValueList(val) {
		 
			return this.Results.map(d => d[val])
		},

	       mounted() {
	       },
	       initialize()
	       {
		       this.fetchApp()
			this.filteredheaders = this.headers;
		
	       },
	        close () {
			this.dialog = false
		},
	       async fetchApp(){
		       await axios.get(this.url + '/api/v1/banneraudit')
			       .then((response) => {
					       this.Results = (response.data);
					       this.progress_bar_loading = false;
					       })
		       .catch(error => {});

         },
          customFilter(items, search, filter) {
                    search = search.toString().toLowerCase();
                    this.fill = items.filter(i => (
                                            Object.keys(i).some(j => filter(i[j], search))
                                            ))
                          
                    return this.fill;
            },
        reset()
                     {
                     this.fetchApp();
                     },
                     download()

                     {
                             var first_record_json;
                             var all_headers;
                             var first_record_json;
                             var first_record_json_keys;
                             var all_headers_not;

                            var local_delete = [];

                             this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));
                             this.headers.forEach(element => this.headerarray.push(element.value));
                             first_record_json = this.Results [0];

                             first_record_json_keys  = Object.keys(first_record_json);
                             all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
                            
                             local_delete = this.fill;
                           
                             for (var k =0;k<local_delete.length;k++)
                             {
                                     for(var i=0;i<all_headers_not.length;i++)
                                     {
                                             var key = all_headers_not[i];
                                             delete local_delete[k][key];
                                     }

                             }
                            



                             var work = XLSX.utils.json_to_sheet(local_delete);



                             var new_workbook = XLSX.utils.book_new();

                             XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
			     var date = new Date();
                             XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
 			     this.filteredheaderarray = [];
                             this.headerarray = [];


                     },

BackgroundColor: function(equipment, key) {
    var result = '';

if(key == 'status')
	{
		if(equipment.status.includes('Overdue'))
		{
		result = 'badge p-2 h-3 font-weight-light badge-warning'	
		}
    else if (equipment.status.includes('Due'))
    {
      result = 'badge p-2 h-3 font-weight-light badge-info'
    }
        else 
    {
      result = 'badge p-2 font-weight-light badge-success'
    }
}

    return result;
  }

 }
}
</script>
